import { FixtureComparisonRating } from '@/service/types';
import { EvaluationTypes } from '../constants';

export const compareEvaluations = (
  evaluation: EvaluationTypes,
  newEvaluation: EvaluationTypes,
) => {
  return (
    evaluation.feedbackText === newEvaluation.feedbackText &&
    evaluation.feedbackType === newEvaluation.feedbackType
  );
};

export const getSupervisorFullName = (supervisor?: FixtureComparisonRating) => {
  return `${supervisor?.user.firstname || ''} ${
    supervisor?.user.lastname || ''
  }`.trim();
};
